"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDateTime = makeDateTime;
exports.timeRangeToDateTimeRange = timeRangeToDateTimeRange;
exports.getMergedBusyTimes = getMergedBusyTimes;
exports.formatRoundRobinAvailability = formatRoundRobinAvailability;
exports.getListOfDays = getListOfDays;
exports.getBookableDays = getBookableDays;
exports.availabilityRecordToDateTimeRangesFromStart = availabilityRecordToDateTimeRangesFromStart;
exports.pushBackStartTimes = pushBackStartTimes;
exports.getConfiguredAvailableTimeRanges = getConfiguredAvailableTimeRanges;
exports.freeDateTimeRanges = freeDateTimeRanges;
exports.isQA = isQA;
exports.getEnvPostfix = getEnvPostfix;
exports.getAnalyticsScriptSource = getAnalyticsScriptSource;
exports.getAnalyticsCanonicalUrl = getAnalyticsCanonicalUrl;
exports.getMarketingProUpgradeUrl = getMarketingProUpgradeUrl;
exports.getVisibleUserTag = getVisibleUserTag;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var TimeRangeListUtils = _interopRequireWildcard(require("MeetingsBase/utils/TimeRangeListUtils"));

var _enums = require("MeetingsBase/constants/enums");

var _dates = require("MeetingsBase/constants/dates");

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _enviro = _interopRequireDefault(require("enviro"));

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

function makeDateTime(_ref) {
  var time = _ref.time,
      date = _ref.date,
      timezone = _ref.timezone;
  return _I18n.default.moment.tz(_I18n.default.moment(date).add(time).format('YYYY-MM-DD HH:mm:ss'), timezone).valueOf();
}

function timeRangeToDateTimeRange(_ref2) {
  var timeRange = _ref2.timeRange,
      date = _ref2.date,
      timezone = _ref2.timezone;
  return _TimeRange.default.from({
    start: makeDateTime({
      time: timeRange.start,
      date: date,
      timezone: timezone
    }),
    end: makeDateTime({
      time: timeRange.end,
      date: date,
      timezone: timezone
    })
  });
}

function getMergedBusyTimes(_ref3) {
  var bookableUsersBusyTimes = _ref3.bookableUsersBusyTimes,
      linkType = _ref3.linkType;

  /**
   * Given the busy times for all users on the link, returns timeslots where
   * no meeting can be booked
   * @param {List} bookableUsersBusyTimes - A list of the busy times for each
   * user on the link. List([List([TimeRange, ...]), ...])
   * @param {string} linkType - The type of the link.
   * @return {List} A flattened list of TimeRanges where meetings cannot be booked
   */
  switch (linkType) {
    case _enums.LINK_TYPES.get(_enums.MEETING_TYPES.PERSONAL):
      return bookableUsersBusyTimes.size ? TimeRangeListUtils.unify(bookableUsersBusyTimes.first()) : (0, _immutable.List)();

    case _enums.LINK_TYPES.get(_enums.MEETING_TYPES.GROUP):
      return TimeRangeListUtils.unifyAll.apply(TimeRangeListUtils, (0, _toConsumableArray2.default)(bookableUsersBusyTimes));

    case _enums.LINK_TYPES.get(_enums.MEETING_TYPES.ROUND_ROBIN):
      return TimeRangeListUtils.intersectAll.apply(TimeRangeListUtils, (0, _toConsumableArray2.default)(bookableUsersBusyTimes));

    default:
      throw Error('Invalid link type');
  }
}

function formatRoundRobinAvailability(availableTimes, allBusyTimes) {
  /**
   * Splits the availability in round robin links when all users in the link
   * have a conflict for a given bookable time slot
   * @param {List} availableTimes - A list of unified TimeRanges that can be booked
   * @param {List} allBusyTimes - A list of the busy times for each
   * user on the link. List([List([TimeRange, ...]), ...])
   * @return {List} A TimeRanges split by user availability
   */
  return availableTimes.reduce(function (acc, value) {
    var busyTimeIntersections = allBusyTimes.map(function (userBusyTimes) {
      return TimeRangeListUtils.timeRangesOfIntersection(value, userBusyTimes);
    });

    if (busyTimeIntersections.every(function (busyTimes) {
      return busyTimes.size > 0;
    })) {
      // If all users have a conflict in this bookable time slot, split up the
      // time slot using the availability of each user separately.
      return acc.concat(busyTimeIntersections.map(function (busyTimes) {
        return TimeRangeListUtils.negate(busyTimes, value.get('start'), value.get('end'));
      }).flatten(true));
    }

    return acc.push(value);
  }, (0, _immutable.List)());
}

function getListOfDays(startTime, daysToAdvertise) {
  /**
   * @param {moment} startTime - Timestamp to start counting days from
   * @param {int} daysToAdvertise - Number of days to list
   * @return {List} List of moments, at the start of each day, at the same
   * time each day, exactly one day apart
   */
  return (0, _immutable.Range)().take(daysToAdvertise).toList().map(function (numDays) {
    return startTime.clone().add(numDays, 'days');
  });
}

function getBookableDays(weeksToAdvertise, customAvailabilityStartDate, customAvailabilityEndDate, now) {
  /**
   * @param {int} weeksToAdvertise - Number of weeks ahead a meeting can be booked
   * @param {int} customAvailabilityStartDate - Date custom availability starts
   * @param {int} customAvailabilityEndDate - Date custom availability ends
   * @param {int} now - Timestamp representing this moment
   * @return {List} List of moments, at the start of each available day
   * in UTC timezone
   */
  var hasCustomAvailability = weeksToAdvertise === _dates.CUSTOM_AVAILABILITY;
  var daysToAdvertise = hasCustomAvailability ? _I18n.default.moment.utc(customAvailabilityEndDate).diff(_I18n.default.moment.utc(customAvailabilityStartDate), 'days') + 1 : weeksToAdvertise * 7;
  var startDate = hasCustomAvailability ? _I18n.default.moment.utc(customAvailabilityStartDate) : _I18n.default.moment(now).utc().day(0);
  startDate.startOf('day');
  return getListOfDays(startDate, daysToAdvertise);
}

function availabilityRecordToDateTimeRangesFromStart(availability, bookableDays, timezone) {
  /**
   * Converts the user's configured weekly availability to a List of TimeRanges
   * representing epoch timestamps of availability for a given list of days
   * @param {AvailabilityRecord} availability - A map of weekdays to configured availability
   * for that day, expressed as minutes from the start of the day
   * @param {List} bookableDays - List of days on which meetings can be booked
   * @param {string} timezone - Configured timezone on meeting link
   * @param {int} now - Timestamp representing this moment
   * @return {List} List of TimeRange, representing availability as configured as
   * epoch timestamps for the given list of days
   */
  return bookableDays.map(function (date) {
    return (// transform static configured availablity for a day -> a list of epoch timeranges
      availability.getForDateString(date).map(function (timeRange) {
        return timeRangeToDateTimeRange({
          timeRange: timeRange,
          date: date,
          timezone: timezone
        });
      })
    );
  }).flatten(true).filter(_identity.default);
}

function pushBackStartTimes(timeRanges, configuredMinimumNoticeTime, now) {
  /**
   * The Minimum Notice Time setting specifies the minimum time needed before
   * a meeting can be booked. To respect this setting, we will push back any
   * start times that happen before the minimum notice time.
   * @param {List} timeRanges - A list of available TimeRanges
   * for that day
   * @param {int} configuredMinimumNoticeTime - Minimum time before meeting can be booked, milliseconds
   * @param {int} now - Timestamp representing this moment
   * @return {List} List of TimeRange, that start at or after the minimum notice time.
   */
  var minimumNoticeTime = configuredMinimumNoticeTime || _dates.TEN_MINUTE_MILLIS;
  var delayedStartTime = TimeRangeListUtils.roundTimeUp(_I18n.default.moment(now).add(minimumNoticeTime), _dates.FIFTEEN_MINUTE_MILLIS);
  return timeRanges.map(function (timeRange) {
    return timeRange.clipStart(delayedStartTime);
  }).filter(_identity.default);
}

function getConfiguredAvailableTimeRanges(availability, weeksToAdvertise, customAvailabilityStartDate, customAvailabilityEndDate, timezone, now) {
  /**
   * Converts the user's configured weekly availability to a List of TimeRanges
   * starting from the proper start date, accounting for custom availability.
   * @param {AvailabilityRecord} availability - A map of weekdays to configured availability
   * for that day
   * @param {int} weeksToAdvertise - Number of weeks ahead a meeting can be booked
   * @param {int} customAvailabilityStartDate - Date custom availability starts
   * @param {int} customAvailabilityEndDate - Date custom availability ends
   * @param {string} timezone - Configured timezone on meeting link
   * @param {int} now - Timestamp representing this moment
   * @return {List} List of TimeRange, starting from the correct start date, in the user's
   * configured timezone, representing available times as configured.
   */
  var bookableDays = getBookableDays(weeksToAdvertise, customAvailabilityStartDate, customAvailabilityEndDate, now);
  return availabilityRecordToDateTimeRangesFromStart(availability, bookableDays, timezone);
}

function freeDateTimeRanges(_ref4) {
  var availability = _ref4.availability,
      settings = _ref4.settings,
      now = _ref4.now,
      bookableUsersBusyTimes = _ref4.bookableUsersBusyTimes,
      linkType = _ref4.linkType;
  var weeksToAdvertise = settings.weeksToAdvertise,
      customAvailabilityStartDate = settings.customAvailabilityStartDate,
      customAvailabilityEndDate = settings.customAvailabilityEndDate,
      minimumNoticeTime = settings.minimumNoticeTime,
      bufferTime = settings.meetingBufferTime,
      timezone = settings.timezone;
  var mergedBusyTimes = getMergedBusyTimes({
    bookableUsersBusyTimes: bookableUsersBusyTimes,
    linkType: linkType
  });
  var paddedBusyTimes = TimeRangeListUtils.addBufferTime(mergedBusyTimes, bufferTime);
  var configuredAvailableTimesOnBookableDays = getConfiguredAvailableTimeRanges(availability, weeksToAdvertise, customAvailabilityStartDate, customAvailabilityEndDate, timezone, now);
  var pushedBackConfiguredAvailableTimes = pushBackStartTimes(configuredAvailableTimesOnBookableDays, minimumNoticeTime, now);
  var availableNonBusyTimes = TimeRangeListUtils.subtract(pushedBackConfiguredAvailableTimes, paddedBusyTimes);

  if (linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.ROUND_ROBIN)) {
    var paddedOnlineUserBusyTimes = bookableUsersBusyTimes.map(function (bookableUserBusyTimes) {
      return TimeRangeListUtils.addBufferTime(bookableUserBusyTimes, bufferTime);
    });
    availableNonBusyTimes = formatRoundRobinAvailability(availableNonBusyTimes, paddedOnlineUserBusyTimes);
  }

  return availableNonBusyTimes;
}

function isQA() {
  return _enviro.default.getInternal('api') === 'qa';
}

function getEnvPostfix() {
  return isQA() ? 'qa' : '';
}

function getAnalyticsScriptSource(portalId, embedded) {
  var qaPostfix = isQA() ? 'qa' : '';
  var embeddedQueryParam = embedded ? '?analyticsCommon=true' : '';
  return "//js.hs-scripts" + qaPostfix + ".com/" + portalId + ".js" + embeddedQueryParam;
}

function getAnalyticsCanonicalUrl() {
  return "" + window.location.origin + window.location.pathname;
}

function getMarketingProUpgradeUrl(portalId) {
  var envPostfix = getEnvPostfix();
  return "https://app.hubspot" + envPostfix + ".com/browse/" + portalId + "/compare/marketing?upgradeSource=meetings-email-auto-prospector-banner&product=pro";
}

function getVisibleUserTag(userProfile) {
  var formattedName = (0, _formatName.default)({
    firstName: (0, _get.default)('firstName', userProfile),
    lastName: (0, _get.default)('lastName', userProfile)
  });
  return formattedName || (0, _get.default)('email', userProfile);
}